/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://dh-static.mesos.nrk.no/dh-orderud-menu/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 17);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerender", function() { return rerender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* harmony default export */ __webpack_exports__["default"] = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = exports.getScrollTop = exports.getScrollLeft = exports.createUniqueId = exports.bem = undefined;

var _array = __webpack_require__(4);

var _bem = __webpack_require__(5);

var _bem2 = _interopRequireDefault(_bem);

var _scroll = __webpack_require__(6);

var _string = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bem = _bem2.default;
exports.createUniqueId = _string.createUniqueId;
exports.getScrollLeft = _scroll.getScrollLeft;
exports.getScrollTop = _scroll.getScrollTop;
exports.toArray = _array.toArray;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connect = exports.Provider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return { '__CTX__': props };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children[0];
    }
  }]);

  return Provider;
}(_preact.Component);

Provider.displayName = 'Provider';

function connect(mapContextToProps) {
  return function (wrappedComponent) {
    var Connected = function (_Component2) {
      _inherits(Connected, _Component2);

      function Connected() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, Connected);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Connected.__proto__ || Object.getPrototypeOf(Connected)).call.apply(_ref, [this].concat(args))), _this2), _this2.mapContextToProps = function (ctx) {
          return mapContextToProps ? mapContextToProps(ctx) : ctx;
        }, _temp), _possibleConstructorReturn(_this2, _ret);
      }

      _createClass(Connected, [{
        key: 'render',
        value: function render() {
          return (0, _preact.h)(wrappedComponent, _extends({}, this.mapContextToProps(this.context['__CTX__']), this.props));
        }
      }]);

      return Connected;
    }(_preact.Component);

    Connected.displayName = 'connect(' + (wrappedComponent.displayName || wrappedComponent.name || 'Component') + ')';
    return Connected;
  };
}

exports.Provider = Provider;
exports.connect = connect;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (true) module.exports = definition();else if (typeof define == 'function' && _typeof(define.amd) == 'object') define(definition);else this[name] = definition();
}('domready', function () {

  var fns = [],
      _listener,
      doc = document,
      hack = doc.documentElement.doScroll,
      domContentLoaded = 'DOMContentLoaded',
      loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);

  if (!loaded) doc.addEventListener(domContentLoaded, _listener = function listener() {
    doc.removeEventListener(domContentLoaded, _listener);
    loaded = 1;
    while (_listener = fns.shift()) {
      _listener();
    }
  });

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  };
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = toArray;
function toArray(nodeList) {
  return [].slice.call(nodeList);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function toStrings(object) {
  return Object.keys(object).filter(function (key) {
    return object[key];
  });
}

exports.default = function (blockName) {
  for (var _len = arguments.length, modifiers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }

  var strings = modifiers.filter(function (modifier) {
    return typeof modifier === 'string';
  });
  var objects = modifiers.filter(function (modifier) {
    return (typeof modifier === 'undefined' ? 'undefined' : _typeof(modifier)) === 'object';
  });

  var objectString = objects.map(function (object) {
    return toStrings(object);
  }).reduce(function (a, b) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }, []);

  return [blockName].concat(strings.map(function (modifier) {
    return blockName + '--' + modifier;
  })).concat(objectString.map(function (modifier) {
    return blockName + '--' + modifier;
  })).join(' ');
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollLeft = getScrollLeft;
exports.getScrollTop = getScrollTop;
function getScrollLeft() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.pageXOffset || document.documentElement && document.documentElement.scrollLeft || 0;
}

function getScrollTop() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.pageYOffset || document.documentElement && document.documentElement.scrollTop || 0;
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUniqueId = createUniqueId;
function createUniqueId() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return '' + prefix + Math.random().toString(36).substr(2, len - prefix.length);
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorReporter = createErrorReporter;

var _dhSimpleErrorReport = __webpack_require__(9);

function createErrorReporter(name, isErrorReportingEnabled) {
  return new _dhSimpleErrorReport.SimpleErrorReport({
    name: name,
    url: 'https://dh.nrk.no/catch',
    dryRun: !isErrorReportingEnabled
  });
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["simple-error-report"] = {});
}(undefined, function (e) {
  "use strict";
  var n = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();var r = function () {
    function e() {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.register = [];
    }return n(e, [{ key: "addErrorToRegister", value: function value(e) {
        this.register.push({ time: new Date(), message: e });
      } }, { key: "isInRegisterWithinRange", value: function value(e, n) {
        return this.register.filter(function (r) {
          return r.message === e && new Date() - r.time < n;
        }).length > 0;
      } }]), e;
  }(),
      t = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];for (var t in r) {
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
      }
    }return e;
  },
      i = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();var o = [],
      s = function () {
    function e(n) {
      var t = n.name,
          i = n.url,
          s = n.dryRun,
          a = void 0 === s || s,
          u = n.parseStack;!function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.name = t, this.url = i, this.errorRegister = new r(), this.dryRun = a, u && (this.parseStack = u), o.push(this.name);
    }return i(e, [{ key: "listenAndCatch", value: function value() {
        var e = this;o.length <= 1 && (window.addEventListener("error", function (n) {
          var r = n.message,
              i = n.filename,
              o = n.lineno,
              s = n.colno,
              a = { message: r };"" !== i && (a.url = i), o > 0 && (a.line = o), s > 0 && (a.column = s), n.error && "function" == typeof e.parseStack ? e.parseStack(n.error).then(function (n) {
            e.sendErrorReport(t({}, a, { stackTrace: n }));
          }) : e.sendErrorReport(a);
        }), window.addEventListener("unhandledrejection", function (n) {
          e.sendErrorReport({ message: "Unhandled Promise Rejection: " + n.reason });
        }));
      } }, { key: "sendErrorReport", value: function value(e) {
        var n, r, t;this.dryRun ? "undefined" != typeof console && console.log("Dry run: " + JSON.stringify(e)) : this.errorRegister.isInRegisterWithinRange(e.message, 500) || (this.errorRegister.addErrorToRegister(e.message), n = this.url + "/" + this.name, r = e, (t = new XMLHttpRequest()).open("POST", n), t.setRequestHeader("Content-Type", "application/json"), t.send(JSON.stringify(r)));
      } }]), e;
  }();e.SimpleErrorReport = s, Object.defineProperty(e, "__esModule", { value: !0 });
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderudLogo = undefined;

var _preact = __webpack_require__(0);

var _index = __webpack_require__(11);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  @jsx h

var OrderudLogo = exports.OrderudLogo = function OrderudLogo() {
  return (0, _preact.h)(
    'svg',
    {
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink',
      x: '0px',
      y: '0px', viewBox: '0 0 469 86.8',
      style: 'enable-background:new 0 0 469 86.8;',
      xmlSpace: 'preserve',
      'aria-hidden': 'true' },
    (0, _preact.h)('path', {
      d: 'M451.3,48.4c-0.8-0.8-1.3-0.6-2.4-0.7c1-1.2,2.1-1.4,3.1-1.3c0.4-0.7-0.3-0.7-0.8-1c0.8-0.7,1.6-0.4,2.4-1.2c0.3-0.7-0.7-0.2-1-0.8c0.2-0.2,0.3-0.4,0.1-0.5c0.4,0.2,0.9,0.3,1.3,0.3c0.5-1.8,0.8-3.8,0.8-5.9c0-9.2-5.3-16.2-14.5-16.2h-12.6v28c0.6,0,1.1-0.1,1.3-0.7c0.7,0.4,1.9,0.5,2,1.1c-0.6,0.5-1.9,0.3-2-0.4c-0.4,1-0.9,1-1.4,0.8v3.4h12.6c2.7,0,5-0.6,7-1.7c-0.1-0.1-0.2-0.2-0.3-0.4c0.2-0.2,0.4,0.1,0.5,0.1c0.1,0,0.2-0.1,0.3-0.1c1.3-0.8,2.5-1.8,3.4-3C451.4,48.3,451.4,48.4,451.3,48.4zM452.4,41c0.6,0.9-1,1.3-1.6,0.6C451.4,41.4,451.9,41.2,452.4,41z M431.4,47.8c-0.3-0.9,1-0.5,1.4-0.8C433,47.9,431.7,47.5,431.4,47.8z M434.8,50.8c1,0.3,2.7,1,3.2,1.8C436.9,52.6,435.9,51.9,434.8,50.8z M440.2,50.8c0.7-0.5,0.5-0.3,0.5-0.9c-0.6-0.3-0.4,1.2-1.2,1c-0.5-1.7,0.9-1.8,2.2-2.1C440.9,49.4,441.4,51.7,440.2,50.8z M440.5,48.6h-7.6V25.6h7.6c6.3,0,9.6,5.2,9.6,11.6c0,1.4-0.2,2.8-0.5,4.1c0.1,0,0.1,0.1,0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.2C448.3,45.8,445.3,48.6,440.5,48.6z' }),
    (0, _preact.h)(
      'g',
      null,
      (0, _preact.h)('path', {
        d: 'M395.7,51.3c0.1-0.4,0.9-0.2,1.1-0.4c0.2,0.6-0.5,0.5-0.9,0.6c1.7,1.2,3.8,2,6.1,2.2c-0.1-1,0.8-1.1,1.8-1.4c-0.3,0.3-0.3,1-0.5,1.4c2.6,0,5-0.8,7-2.2c-0.2,0-0.5,0-0.8-0.1c0.7-0.8,1.4-1,2.1-1c0.1-0.1,0.3-0.3,0.4-0.4c-0.1-0.2-0.4-0.2-0.7-0.4c0.5-0.4,1-0.4,1.5-0.7c0.1-0.2,0.3-0.4,0.4-0.6c-0.1-0.1-0.6,0-0.8-0.4c0.2-0.2,0.2-0.3,0.1-0.4c0.4,0.2,0.7,0.2,1,0.2c0.7-1.2,1.2-2.7,1.4-4.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2-0.4,0-0.6,0.3-0.7c0-0.3,0-0.6,0-0.9V20.9h-5v19c0.3,0.1,0.6,0.2,1,0.4c-0.4,0.6-0.9,0.8-1,0.2c0,0,0,0,0,0V41c0.1,0.2,0.2,0.3,0,0.5V42c0,0.3,0,0.6,0,0.8c0.5,0,1,0.2,1.5,0.3c0.3,0.5-0.6,0-0.8,0.3c0.4,0,0.8,0.4,1.2,0.8c-0.7,0.2-1.4-0.6-2-0.5c-0.2,0.9-0.6,1.6-1.1,2.3c0.3,0.3,0.8-0.1,1.3,0.4c-0.7,0.5-1.4,0.4-2,0.4c-1.3,1.3-3.1,2-5,2c-2.5,0-4.8-1.2-6-3.3c0,0.1-0.1,0.1-0.1,0.2c-0.3-0.5-0.3-0.5-0.9-0.8c0.2-0.1,0.4-0.1,0.7-0.1c-0.4-0.9-0.6-1.8-0.6-2.9V20.9h-5.1V42C391.2,46.1,393,49.3,395.7,51.3z M410.6,39.4c-0.5-0.2,0-0.6-0.3-0.8c0.3-0.5,0.7,0.3,1,0.1C411.6,39.2,410.7,39.1,410.6,39.4z M412.3,46.2c0.5,0.7-0.8,1-1.2,0.5C411.4,46.6,411.9,46.4,412.3,46.2z M400.1,51.1c-0.3,0.3-0.1,0.5-0.4,0.7c-0.6-0.5-1.1,0.1-1.7-0.4C398.2,50.4,399.3,50.9,400.1,51.1z' }),
      (0, _preact.h)('path', { d: 'M403,53.2c-0.3-0.1-0.3,0.2-0.5,0.5c0.1,0,0.3,0,0.4,0C403.1,53.6,403,53.6,403,53.2z' })
    ),
    (0, _preact.h)('path', {
      d: 'M372.5,50.3c0.8,0.5,1-0.9,1.9-0.1c-0.5,0.4-0.9,1.1-1.6,0.8c-0.1,0.1-0.1,0.1-0.1,0.1l1.4,2.1h6l-6.5-9.3c-0.1,0-0.1,0-0.2-0.1c0,0,0-0.1,0.1-0.1l-1.8-2.6c6-0.7,8.3-5.3,8.3-10c0-5.2-2.9-10.3-9.8-10.3h-12.6v32.3h5V41.4h3.5l6.3,9.2C372.4,50.5,372.5,50.4,372.5,50.3z M378.4,33.8c-0.6,0.8-1.5,0.3-2.3,0.4C376.8,33.8,377.7,33.9,378.4,33.8z M362.7,36.8v-4.9c-1.1,0.1-2.4,0.6-3.1,0.1c0.4-0.4,1.6,0.2,2.1-0.9c0.5,0.4,0.6,0.4,0.9,0.6v-6.1h7.4c1.9,0,3.2,0.9,4,2.2c0,0,0,0,0.1-0.1c0,0.1,0.1,0.2,0,0.3c0.5,1,0.8,2.1,0.8,3.3c0,2.8-1.5,5.6-5.1,5.6H362.7z M372.6,43.4c-0.6,0.9-1.6,0.6-2.4,1C370.2,43.3,371.8,43.3,372.6,43.4z M375,46.3c-0.1,0.2-0.3,0.5-0.4,0.7c-1.2-1-1.8-0.1-2.8-0.4C373,45.5,373.9,46,375,46.3z' }),
    (0, _preact.h)('path', {
      d: 'M331.3,39.6H344v-2.2c-0.6,0.1-1.2,0-1.9-0.5c0.5-0.6,1.2-0.6,1.9-0.5v-1.4h-5.5c0.1,0.1,0.3,0.3,0.4,0.5c-0.8,0.6-1.1-0.1-1.5-0.5h-6.1v-9.6h14.5v-4.6h-19.5v32.3h19.9v-4.5h-15V39.6z M338.4,36.5c-1.1,0.2-2.9,0.3-3.7-0.4C335.8,35.8,337.5,35.7,338.4,36.5z M340.8,49.5c0.4,0.3,0.9,0.5,0.6,1C340.8,50.7,340.5,50,340.8,49.5z M337.6,49.3c0.4,1.1,1.2,0,2,0.6c-1.4,0.6-3.1,0.1-4.7,0C335.5,48.7,336.9,50.1,337.6,49.3z M326.5,50.4c0.8-0.5,1.9,0,2.6-0.9c0.3,0.1,0.6,0.5,0.8,0.2C330.4,51.5,327.7,50.9,326.5,50.4z M328,49c0.1-0.6,1.2-1.6,2.1-0.9c-0.7,0.2-0.2,0.7,0.4,0.9C329.9,49.5,328.9,49,328,49z M329.3,32.4c0.4-0.3,0.8-0.3,1.4,0.1C330.4,33.1,329.7,32.3,329.3,32.4z' }),
    (0, _preact.h)('path', {
      d: 'M300.5,20.9H288v22.7c0.3-0.2,0.7-0.1,1.1,0c-0.3,0.4-0.6,0.4-1.1,0.3v9.3h12.6c9.2,0,14.5-6.9,14.5-16.1C315.1,28,309.7,20.9,300.5,20.9z M291.7,39.3c-0.6,0.9-1.6,0.6-2.4,1C289.2,39.2,290.8,39.2,291.7,39.3z M289.1,49c0.8-0.5,1.9-0.1,2.8-0.1C291.1,49.5,290.1,49.2,289.1,49z M293.1,52.7c0.7-0.6,0-1.9,1.3-2.3c0.1,0.5-0.1,1-0.4,1.6c0.7,0.3,1.4,0.4,1.8-0.4c0.1,0.3,0.3,0.5,0.8,0.7C295.6,52.8,294.6,53.5,293.1,52.7z M300.5,48.6h-7.6v-2c-0.3,0.3-0.6,0.4-1,0.2c-0.5,0.5,0.5,0.5,0,0.9c-0.6,0.3-1.4-0.1-2,0.3c-0.2-0.9,1.3-0.4,1.8-0.7c0.2-0.5-0.4-0.7,0-1.2c0.6,0.3,0.9-0.4,1.4-0.4v-3.3c-0.8-0.3-1.4,0.2-2.1,0c0.8-0.7,1.5-0.8,2.1-0.6v-2c-0.1,0-0.3-0.1-0.4-0.1c0.1-0.2,0.3-0.5,0.4-0.7V25.6h7.6c6.3,0,9.6,5.2,9.6,11.6C310.1,43.6,306.9,48.6,300.5,48.6z' }),
    (0, _preact.h)(
      'g',
      null,
      (0, _preact.h)('path', { d: 'M271.2,39.9c-0.1,0.1-0.2,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C271.4,40,271.3,40,271.2,39.9z' }),
      (0, _preact.h)('path', {
        d: 'M269.1,40.9c0.1-0.4,0.6-0.4,1.2-0.4c0.2-0.1,0.4-0.2,0.6-0.3c0-0.3-0.4-0.5-0.1-1c0.8,0.4,1-0.9,1.8-0.2c1.9-1.6,2.9-3.8,3.2-6.3c-0.8,0.1-1.5,0.1-2.4,0c0.7-0.5,1.8,0.2,2.4-0.6c0-0.3,0-0.7,0-1c0-5.2-2.9-10.3-9.8-10.3h-2.4c-0.4,0.2-0.9,0.1-1.4,0h-1.8c-1,0.2-2.1,0.5-2.7,0c0,0,0,0,0,0h-4.4v12c0.1,0,0.1,0,0.2-0.1c0.1,0.2,0,0.2-0.2,0.3v20.1h5V41.4h3.5l8.1,11.9h6l-8.5-12C268.2,41.1,268.7,41,269.1,40.9z M254.1,33c0.2-0.8,1.1-0.2,1.3,0.2C255,33.4,254.5,33.3,254.1,33zM272.3,32.1c0.1,0.3,0.3,0.5,0.8,0.7c-0.3,0.3-0.7,0.2-1.2,0C272,32.6,272.1,32.4,272.3,32.1z M273.3,35.3c-0.1,0.2-0.3,0.5-0.4,0.7c-1.2-1-1.8-0.1-2.8-0.4C271.4,34.5,272.2,35,273.3,35.3z M262.5,22.1c0.8,0.6,1.5,0.7,2.1,0.5c0.6,0.5-0.2,0.6-0.4,1.2c-0.3-0.8-1.4-0.7-2.1-0.9C262.6,22.6,262.2,22.5,262.5,22.1z M258.5,36.8V25.5h7.4c3.5,0,4.9,3,4.9,5.7c0,0.4,0,0.8-0.1,1.1c0.1,0,0.2,0,0.2,0c-0.1,0.1-0.2,0.2-0.3,0.3c-0.4,2.2-2,4.2-4.9,4.2H258.5z M268.3,36.7c-0.3,0.4-0.8,0.3-1.3,0.2C267.4,36.5,267.8,36.6,268.3,36.7z' })
    ),
    (0, _preact.h)('path', {
      d: 'M226,20.6c-8.2,0-14.8,6-16.1,13.8c0.2-0.1,0.3-0.3,0.5-0.5c0.6,0.5,0.6,0.4,1.4,0.8c-0.6,0-1.3,0.2-2,0.3c-0.1,0.7-0.1,1.5-0.1,2.2c0,7.7,5,14.1,12,16c0.4-0.2,0.7-0.8,1.4-0.1c-0.1,0.1-0.3,0.3-0.4,0.4c1.1,0.2,2.2,0.3,3.3,0.3c9.2,0,16.4-7.4,16.4-16.6C242.4,28,235.2,20.6,226,20.6z M214.5,34.5c-0.6,0.6-1.5,0.3-2.4,0.1C212.8,34.1,213.6,34.3,214.5,34.5zM217.3,50.7c0.3-0.4,0.8-0.3,1.3-0.2C218.3,51,217.8,50.9,217.3,50.7z M223.2,49.8c-1.2-1-1.8-0.1-2.8-0.4c1.3-1.1,2.1-0.7,3.2-0.3C223.5,49.3,223.4,49.6,223.2,49.8z M226,48.8c-2.3,0-4.5-0.7-6.3-1.9c-0.3,0.1-0.6,0.1-0.8,0.3c0-0.3,0.1-0.5,0.3-0.7c-2.8-2.1-4.5-5.5-4.5-9.4c0,0,0,0,0,0c-0.1,0.1-0.2,0.2-0.2,0.3c-0.3-0.8-1.4-0.7-2.1-0.9c0.5-0.2,0.1-0.2,0.4-0.7c0.7,0.5,1.4,0.6,1.9,0.5c0.4-6.1,5.2-10.9,11.3-10.9c6.4,0,11.4,5.3,11.4,11.7C237.4,43.6,232.4,48.8,226,48.8z' }),
    (0, _preact.h)(
      'g',
      null,
      (0, _preact.h)('path', {
        d: 'M77.9,18c2.9,0,5.2-2.3,5.2-5.1c0-3-2.3-5.2-5.2-5.2c-2.8,0-5.1,2.3-5.1,5.2C72.9,15.7,75.1,18,77.9,18z M77.9,10.3c1.4,0,2.6,1.1,2.6,2.6c0,1.3-1.2,2.4-2.6,2.4c-1.4,0-2.4-1.1-2.4-2.4C75.5,11.4,76.6,10.3,77.9,10.3z' }),
      (0, _preact.h)('path', {
        d: 'M89,42.8c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.2,0.2-0.2l-5.3-14.1c-0.5-0.1-1.1-0.6-1.5-0.5c0.4-0.3,0.8-0.4,1.3-0.3l-0.6-1.6c-0.7,0.2-1.6-0.2-0.8-1.1c0.2,0.1,0.3,0.2,0.5,0.3L82,24.2c-0.3-0.1-0.6-0.2-0.9-0.4c0.2-0.2,0.4-0.3,0.6-0.3l-1-2.6h-5.4l-7.8,20.7c0.1,0,0.3,0,0.4,0.1c-0.2,0.2-0.4,0.3-0.6,0.4l-4.2,11.2h5.3l1.7-4.6c-0.5-0.1-1.1-0.5-1.6-0.7c0.5-0.4,1.2-0.3,1.9,0l1.1-2.8h13l3.1,8.1h5.3L89,42.8z M73.2,40.7L78,27.2l4.8,13.6H73.2z M88.1,46.6c-0.6-0.5-1.2-1.5-1.8-0.7c-0.7-0.3,0.9-1.2-0.4-1.3c0.3-0.7,1,0.1,1.3-0.4C86,45.5,88.8,44.7,88.1,46.6z' })
    ),
    (0, _preact.h)('path', {
      d: 'M147.5,49.3c-0.8,0.7-2,0-3.1,0c0-0.2,0.1-0.4,0.3-0.6h-3.5c0.1,0.1,0.2,0.1,0.3,0.2c-0.5,0.1-1.3,0.3-1.6-0.2h-3.4v-3.8c-0.3-0.1-0.6-0.3-0.9-0.5c0.3-0.2,0.6-0.2,0.9-0.2v-4.7h12.7v-4.5h-12.7v-9.6h14.5v-4.6h-14.6c1,0.1,1.9,0.5,2.7,1.4c1.8,0,3.2-1,5.1-0.6c-0.2,0.6-0.6,0.6,0.3,1.5c-3.5,0.5-7.6-1.2-11.2-1.1c-0.4-0.9,1.2-0.4,1.7-0.5c0.1-0.6-0.9-0.2-1.5-0.8h-2v7.6c0.5,0.1,1.1,0.3,1.6,0.5c-0.5,0-1.1,0-1.6,0v24.1h19.9v-4.5h-4.9C146.7,48.9,147.1,49.2,147.5,49.3z M146.9,22.1c0.7,0.5,0,1.9-0.8,1.5C146.8,23.4,146.3,22.8,146.9,22.1z M133.1,40c0.6-0.4,1.3-0.4,2.1-0.2C134.6,40.3,133.8,40.1,133.1,40zM142.6,51.1c1-0.6,2.3,0,3.1-1.1c0.4,0.2,0.8,0.6,1,0.3C147.2,52.3,144,51.7,142.6,51.1z' }),
    (0, _preact.h)('path', {
      d: 'M186.8,45v-0.8c0,0-0.1,0-0.2,0c0-0.1,0.1-0.2,0.2-0.2V20.9h-5v2.7c0,0.1,0.1,0.1,0.1,0.2c0,0-0.1,0-0.1,0v20.1l-13.7-22.9h-4.8v32.3h5V30.1c-0.8,0-1.7-0.1-2.7-0.7c1.2-0.3,2.5,0.1,3.9,0.6c-0.4,0-0.8,0-1.3,0l13.9,23.1h0.9c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.2,0.1,0.3,0.2h3.2V45C186.8,45.1,186.8,45,186.8,45z M184.5,22.4c0.8,0.5,0,2-0.9,1.6C184.4,23.9,183.9,23.2,184.5,22.4zM181.8,52.3c0.1-0.8,1.6-2.1,2.8-1.2c-1,0.3-0.3,0.9,0.6,1.2C184.3,53,183,52.3,181.8,52.3z M183.3,27.9c0.4,0.2,0.8,0.4,1.2,0.6C184.2,29.1,182.4,29.1,183.3,27.9z M183.5,30.5c0.5-0.4,1.1-0.3,1.8,0.1C184.9,31.4,184,30.4,183.5,30.5z M182.7,26.9c0.9-0.8,2.1-0.3,3.4,0C185.1,27.6,184,27.6,182.7,26.9z' }),
    (0, _preact.h)('path', {
      d: 'M97.6,25.6h9.5v1c0.6,0.1,1.2,0.2,2-0.2c0.5,0.4,0.4,0.9-0.1,1.5c-0.1,0.4,0.4,0.6,0.7,0.8c-0.7,0.2-2.1,0.4-2.4-0.6c1.2-0.3,0.6-0.5-0.3-0.6v25.7h5.1V32.1c-0.4-0.1-0.7-0.2-1-0.3c0.3-0.2,0.6-0.3,1-0.3v-5.9h9.5v-4.6H97.6V25.6z M104.4,22.9c-0.6,1-1.8,0.1-2.9-0.4C102.2,21.9,103.3,22.4,104.4,22.9z' }),
    (0, _preact.h)('path', {
      d: 'M49.4,50.8c0.5-1.1,1.4-1,2.3-0.9c3.1-2.8,5-7.2,5-13.4H41.9v4.3h4.4c-0.6-0.5-1.2-1.5-1.9-0.6c-0.8-0.3,0.9-1.3-0.4-1.4c0.3-0.7,1,0.1,1.4-0.4c-1.3,1.3,1.6,0.5,1,2.4h4.6c-0.2,4.8-4.4,7.9-9.6,7.9c0.2,0.2,0.5,0.3,0.8,0.4c-1.2,0.9-2.9,0-4.3,0c0-0.2,0.2-0.5,0.4-0.8c-4.9-1.4-8.4-6-8.4-11.5c0-6.5,5-11.9,11.4-11.9c3,0,5.6,1.2,7.6,3l0.4-0.4c-0.1-0.1-0.2-0.1-0.2-0.1c0.2,0,0.3-0.1,0.5-0.1l2.9-2.6c-2.8-2.8-6.8-4.5-11.3-4.5c-8.8,0-15.7,6.8-16.3,15.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0.4-0.1,0.8-0.1,1.1c0,1.9,0.3,3.7,0.9,5.4c0.7-0.4,1.7,0,2.7,0.5c-0.6,0.9-1.7,0.2-2.7-0.3c2.2,6.4,8.2,11,15.4,11c3.6,0,6.7-0.8,9.2-2.5C50.1,50.8,49.8,50.8,49.4,50.8z M47.7,37.7c0.8-0.9-0.4-0.8-0.7-0.8c0-0.5,2.5-0.1,3.7,0.5C49.8,38.1,48.8,38,47.7,37.7z M47,22c-0.5,1-1.6,0.3-2.6-0.3C45.1,21.2,45.9,21.3,47,22z M42.2,21.3c-0.4,1.1-1.6-0.2-2.3-0.1C40.6,20.8,41.3,20.8,42.2,21.3z M31.5,47.9c2-0.5-1.2-0.6-2.1-1.2c1.4-1.2,2.2,0.2,3.9-0.6c0.5,0.4,0.4,0.9-0.1,1.5c-0.1,0.4,0.4,0.6,0.7,0.8C33.2,48.6,31.8,48.8,31.5,47.9z M35.3,51.5c1.4-0.8,3.2,0,4.4-1.5c0.5,0.2,1.1,0.8,1.4,0.4C41.8,53.2,37.3,52.3,35.3,51.5z' }),
    (0, _preact.h)(
      'g',
      null,
      (0, _preact.h)(
        'g',
        null,
        (0, _preact.h)(
          'g',
          null,
          (0, _preact.h)(
            'g',
            null,
            (0, _preact.h)('path', {
              className: _index2.default.st0,
              d: 'M213.8,66.7c2.2-0.5,6.9-0.7,6.8,0.1c0.1-0.8,0.1-0.8,3.3-1.4c-0.1,0.5,2.8,0.4,4.7,0.3c-1.5-0.4-3.6-0.4-7.8-0.5c-3.8,1.2-11.7-0.5-15.3,0.8C208,66.3,210.6,67.1,213.8,66.7z' }),
            (0, _preact.h)('path', { className: _index2.default.st0, d: 'M230.9,70l0.6-0.3l-6.6,0.5C226.2,70,230.7,69.7,230.9,70z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M252.3,69c-0.6,0.6,2.8,0.9,2.7,1.4c-0.1-1.1,5.3-0.3,8.2-0.5l1.2-0.9c-2.8-0.6-9.9-0.3-16-0.3L252.3,69z' }),
            (0, _preact.h)('path', { className: _index2.default.st0, d: 'M257.7,69.6l1.9-0.6C258,69.2,254.4,69.3,257.7,69.6z' }),
            (0, _preact.h)('path', { className: _index2.default.st0, d: 'M253.6,66.5c-4.7,0,2.8,0.3-1.9,0.6C253.3,67,255.2,66.9,253.6,66.5z' }),
            (0, _preact.h)('polygon', { className: _index2.default.st1, points: '273.4,68.1 263.3,68.6 267.5,69' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M273.9,70c-1.3,0-3.4-0.3-1.5-0.6c3.6,0.7,5.8-0.4,9.2,0.2l-3.2,0.3c0.4,0.7,6.6-0.8,6.5,0.5c4.3-1-3.3-1.1,2.3-1.8c-5.3,0.3-9.2,0.1-13.6-0.1c1.3,0.3,1.8,0.2,3.6,0.4c-3.2,0.1-7.4,0.5-11.1,0.6C268.1,70.3,270.8,69.5,273.9,70z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M289.9,70c3.4,0,8.7,0,9.5-1c-3.6-0.6-4.2,0.2-5.8,0.6c-1-0.1-4.4-0.2-3.1-0.7C291.1,69.1,288.4,69.6,289.9,70z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M303.3,69.9l2.5-0.9l-1.6,0.2l-0.2-0.6c-0.3,0.2-1.5,1.3-4.9,1.3C300.9,70.3,301.5,69.8,303.3,69.9z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M304,65.6c2.3,0.4,3.7,0.1,6.3-0.2c-3.7,0.1-8.9,0.2-10,0.6l0.3-0.2c0,0-3.5,0.5-5.9,1.1C298.5,66.3,305.2,67.2,304,65.6z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M299.3,65.6l2.7-0.5L299.3,65.6z' }),
            (0, _preact.h)('polygon', { className: _index2.default.st1, points: '313.8,69.6 308.6,69.4 309.9,69.6' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M307.6,67c4.2,0.1-2.3-0.7,1.6-0.7c1.1-0.1-5.8,0.1-6.1,0.5C304.1,67,307.1,66.3,307.6,67z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M317.2,69.6l4.3-0.7L317.2,69.6z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M327.9,69.9l0.8-0.5c4.2,0.3,9.7-0.4,12.8,0.5c-0.7-0.6,1.7-1.2-1.9-1.3c-0.6,0.3-1.9,0.3-1.7,0.7c-1.6-0.1-1.2-0.5-2.3-0.7c-2.7,0.5-6.8,0.2-9,0.7c1.1-0.1,1.3,0,2.1,0c-4.6,0.9-5.4-1.1-7.4,0.3C323,69.3,325.8,70.1,327.9,69.9z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M327.5,66.7l-3.7-0.1c1.1-0.6,4.5-0.1,5.1-0.7c-0.2-0.4-3.9-0.5-2.5-0.8c-0.4,1.5-5,0.2-3.1,1.7c-4.7,0.3-1.5-0.9-6.5-0.7l-1.4,0.8C321,66.5,321.9,67.2,327.5,66.7z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M341.6,66.7l1.8,0.4l-1-0.7c8.2-0.2,13,2.5,17.9,2c6.1-1,11.9,0.2,18.2,0c3-0.6-2.9-0.3-3.3-0.7c0.9-1.2,3,0.6,4.4-0.4c0.4-0.8-6.4-0.8-9.1-1.2c-2.3,0.2-2.3,0.4-3,0.9c-0.6-0.5-3-0.6-3.6-1c-4.9,0.7-7.5-0.5-12.3,0.3c-1.5-0.6,3.6-0.2,2-0.3l-2.6,0.1l0.3,0.1c-3.6,0.7-10.2,0.2-12.5-0.2c1.8,0.2,3.1,0.7,0.9,0.9l-1.8-0.7l-4.6,1.1C336.9,66.7,341,68.1,341.6,66.7z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M336.5,65.5c-5.5-0.3,0.7,1.1-5.3,0.8l6.3-0.2L336.5,65.5z' }),
            (0, _preact.h)('path', { className: _index2.default.st0, d: 'M362.7,66.9l2.7,0.5C363.9,66.3,359.7,67.8,362.7,66.9z' }),
            (0, _preact.h)('polygon', { className: _index2.default.st0, points: '372.7,66.7 371.3,67.7 373.8,67.1' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M381.8,67.7c2-0.5-0.4-0.9-2.8-0.7C381.2,67,382.3,67.4,381.8,67.7z' }),
            (0, _preact.h)('path', { className: _index2.default.st0, d: 'M396.8,69.2c-4.6,0.1,4.1,0.2,0.8,1.1C398.2,69.9,400.5,69.3,396.8,69.2z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M411.7,71.2c-1.7,0.2-2.3,0.1-2.6-0.2C410.3,71,411.3,71,411.7,71.2z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M354.5,69.3c-0.5,0-1.1,0-1.6,0C353.4,69.3,353.9,69.3,354.5,69.3z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M355.5,69.3c-0.3,0-0.7,0-1.1,0C354.9,69.3,355.2,69.3,355.5,69.3z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M389.6,70.7C389.6,70.7,389.6,70.7,389.6,70.7c-0.1,0-0.3,0-0.4-0.1L389.6,70.7z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M244.3,70.3c-0.9,0.1-1.6,0.1-2.1,0.1C242.8,70.4,243.6,70.4,244.3,70.3C244.3,70.3,244.3,70.3,244.3,70.3z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M241.8,69c3.8-0.6,4,1.4,10.1,0.9c-2.5,0.2-5,0.3-7.7,0.4C240.7,69.4,246.9,69.8,241.8,69z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M292.6,67.4c0.1,0,0.1,0,0.2,0C293.2,67.3,293,67.3,292.6,67.4z' }),
            (0, _preact.h)('polygon', { className: _index2.default.st0, points: '76.3,70.7 76.3,71 72.9,70.7' }),
            (0, _preact.h)('path', { className: _index2.default.st0, d: 'M76.8,71.2l5.7,0.5l-33.9,0.1l1.1-0.4C49.3,71,77.8,71.7,76.8,71.2z' }),
            (0, _preact.h)('path', { className: _index2.default.st0, d: 'M78.4,70.8c3.3-1.1,5.5,0.4,9.5-0.4c-2.7,0.5-4.6,1.1-7.2,0.8L78.4,70.8z' }),
            (0, _preact.h)('path', { className: _index2.default.st2, d: 'M89.7,68.7c1.8,0.2,4-0.2,5-0.1C94.1,69.5,91.2,68.9,89.7,68.7z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M94.6,65.6c0.3,0,0.6,0,0.8,0c-0.3,0.1-0.6,0.1-0.9,0.2L94.6,65.6z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M94.5,65.7l0,0.4C93.9,66,94.1,65.9,94.5,65.7z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M95.4,65.6c0.7-0.1,1.6-0.2,2.1-0.4l-0.8-0.1c1.1-0.1,2.9-0.4,3.4-0.2c-2.1-0.1-2.1,0.2-2.2,0.7l3.4,0.1C100.7,67,98.4,65.7,95.4,65.6z' }),
            (0, _preact.h)('path', { className: _index2.default.st2, d: 'M106.1,65.3l-3.5,0.7C101.7,65.3,104.8,65.3,106.1,65.3z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M111.3,66.1c-0.8,0.2-4.2,0.1-2.2,0.5c-0.6,0.1-1.2,0.1-1.9,0.1C109.5,66.5,107.4,65.6,111.3,66.1z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M107.2,66.6c-0.3,0-0.6,0-1,0C106.6,66.6,106.9,66.6,107.2,66.6z' }),
            (0, _preact.h)('path', { className: _index2.default.st2, d: 'M70.7,69.7c0.4,0.1,0.4,0.2,0.2,0.3L70.7,69.7z' }),
            (0, _preact.h)('path', { className: _index2.default.st1, d: 'M118.3,66.8l1.3,0c-0.4,0-0.7,0-1.1,0L118.3,66.8z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M9.5,73.2c4.6,0.2,8.9,0.5,15.5,0c-0.1-0.9,2.7-0.2,3-1.2c-6.8,0.1,25.8-0.5,20.3-0.9l-1.6,0.4l1.7-0.9c3.3,0.2,7.8,1,10,0.5c0.6,0.3-27.9,0-26.9,0.2c-2.5-1.1,38.2-0.9,39.3-1.4l0.5,0.6c5.1-0.6,8.3-1.4,12.6-1.8l1,0.7c-3.1-0.2-4,0.2-7.2,0.5c5.5-0.1,6.5,0.3,10.7,0.2c-0.1-0.9-3.6-0.4,1.7-0.9c1.5,0.4-2,1.3,2.7,1.2c5.7,0.2,4.6-1.1,9.6-1.2l-3.4-0.3c1.8,0,5.3-0.2,7.1,0.2c-2.1-0.1-7.4,0.4-7.3,1.3c2.1-0.2,6.8,0.1,8.6,0.1l-1.1,0.6c2,0.6,3.2-0.3,5.7,0.2c2.4-0.4-1.5-0.9-0.1-1.1c0.5,0.2,5.2,0.5,6.8,0.1c-1.1-1.3-5.6,0.4-8.5-0.9l4.4,0.2c2.8-1.3-7.1,0-5.7-1c3.3-1.3,6.9,1.3,10-0.4c-2.1-0.3-8.6-0.3-7.8-0.8c2.3,0.5,4-0.4,7.2-0.6l3.9,0.6c1.6-0.4,0.3-0.4-1-0.7c5.7,0.7,15.2-0.2,23.3,0.7c4.7-0.2,0.6-0.6,2.8-1c2.5,0.8,6.8,0.1,9.4,0.1c0.8,0.1,2.2-0.7,1.4-1l-6.6,0.5c0.3-0.4-0.7-1.1-3-1c1.6,1.5-9.3-0.9-9.8,0.8l0.1-0.8l-8.5,0.6l0.3,0.1c0-0.3-7.2,0.6-11.8,0.2c1.3-0.3,9.2,0,4.6-0.8c3.5-0.5,9.7,0.2,16-0.1l-1.2-0.5c6.7-0.8,15.5,0.2,22.8,0l-2.2,0.7c2.6,0.3,5.9,0.8,8.4,0.2c-3.2,0.1-1.5-0.4-1-0.7c4.2-0.4,10.5,0,16.3-0.3c0,0-0.3,0.2,0,0.3l6.1-0.5c2.9,0.1,3.9,0.5,5.6,1c1.1-0.1,3.7-0.1,2.7-0.5c-0.6,0-1.1-0.1-1.5,0c3.1-0.8,2.2,0.2,6-0.3c-3,0.7,0.9,0.9,0.6,1.6c4.5-0.3,0.4-1.2,1-1.5c5.5,0.4,6.2,0.9,11.7,1c0.3-0.4-3.9-0.2-4.4-0.7c1.6,0.1,3.4,0,3.7-0.1l-3.4-0.3c5.7,0.4,11.2,0.5,17.5,0.1l-0.5-0.2l3.9,0l-1.4,0.8c2.1-0.2,4.4,0.5,5.5-0.2l-0.8,0l2.7-0.3l-2.7,0.8c3.4,0.3,8-1.3,13.5-1.3c1.2,1-9.5,0.5-10.2,1.8c1.8,0.2,4.9,0.4,6,0c-0.2-0.4-1.5-0.4-2.8-0.3c4.8-0.8,12,0.3,15-0.9l-3.6-0.4c4.2-0.2,6.9,1.2,8.3,0.4l-3.3,1.4c4.3-0.7,9.8-0.6,13.8-1.2c0.1-0.8-5.8,0.1-5.5-0.1l1.9-0.6c6.2,0.4,1.8,0.5,9.3,0.8l0.1-0.5c2.5,0.8,9.3-0.8,6.7,0.6l-2.1-0.3l0.2,0.6l8.7-0.5c-0.8,0.5,3.4,0.3,2.2,0.9l3.2-0.6c1.5,0.9-5.9,1.1-6.2,1.8c0.1,0.4,1.6,0.3,2.4,0.3c-3.9,0.7-5.8-0.8-9.6-0.8l-1.9,0.6l0.1-0.8c-1.6,0.2-3,0.7-3.5,1c-3.8-1-7.9,0.3-13.6,0.1c4.8-0.5-3.1-0.7-2.2-0.9c-2.6,0-9.1,1.5-11.3,0.5c-1.5-0.4,3.2-0.6-0.4-0.7c-2.4,0.1-4,0.5-2.5,0.9c-5.3,0.3-11.6,0.2-17.3,0.2l1.4-0.5c-3.6-0.4-7.1,0.3-9,0.9c-0.5-0.2-0.8-0.1-0.2-0.4c-4.6-0.8-5.9,1.1-13.5,1c0.4,0.7,3.8,0.8,6.2,0.4l-0.6,0.8c6.6,0,13.9-0.3,19.2-0.8l-2.4,0.6c4.6,1.1,3.3-1.1,7.6,0.1c3.2-0.3-2.3-0.4,0.1-0.8c2.3,0.2-0.6,1.4,3.2,1.5C228,71,211.8,71,197,71.3c-0.3,0.2,0.5,0.2,1.3,0.3c-5.1,1.2-46.5-1.6-47.8,0.5c-0.7-0.3,1.7-0.7-1.5-0.6c-0.3,0.2-1.1,0.4-0.3,0.7c-8-1.2-18.6,0.1-28.3-0.6c0.2,0.4-1.9,0.6-1.9,0.8c-3.3-0.8-8.9,0.1-12-0.4l1,0.4l-9.7,0c-0.3,0.2,1,0.2,1.8,0.2c-2.1,0.2-2.6-0.3-2.8-0.6l-4.3,0.9c-12.7-1.5-28.5,0.8-43-0.2c-2.2,0.7-4.1,1-7.8,1.1l1.8,0.2c-3.8,0.6-0.2-0.4-3.4-0.1c-2.2,0.5-0.7,1.1,2.3,0.7c1.8,0.2,0.7,0.5-0.6,0.7C29.9,75.1,19,74.6,9.5,73.2z' }),
            (0, _preact.h)('path', {
              className: _index2.default.st1,
              d: 'M452.5,72.1c-1.3-0.3,5-0.4,1.9-1.1c-9.8-1.2-25.7,0.3-37.3-0.6c-3.1-0.5-3.9-0.5-6.7-0.7c-0.1,0.1-0.1,0.3,0.1,0.4c-3.2,0-8.3,0.3-11.4,0c-0.9,0.2-1.5,0.7,0.2,0.6c-4.8,0.6-8.3-0.9-11-0.4c2.3,0.3-2.3,0.6,0.5,0.8c-5,0.2-4.6-1.8-8.6-2c-0.2,0.2-0.5,0.3,0.3,0.4c-4.4-0.8-13.3,0.7-13.8-0.7l-1.7,0.6c-1.9-0.4-1.4-0.7-4.6-0.9c-2.1,0.3,0.1,0.5-0.7,0.7c-0.9-0.6-6.4-0.2-9-1c-0.2-0.9,4.5,1.1,7,0.3c0.1-0.2-0.3-0.2-0.8-0.2c13.2,0,23.2,2.3,34,1.4c2.4,0.6,4.2,0,5.3-0.7c-2-0.2-7.5-0.7-7.6,0.5l-3.4-0.7c-1.3,0.1-1.3-1.2-1.8-1.4c2.4,0.1,5.1-1.2,1.8-1.6c6.3-0.3-2,2.7,3.6,2.2l0.8-0.9c-1,0.5,3.8,0.8,5.6,0.5l-0.7-0.2c14.8,0.2,34.5-0.7,50.9-1.3c4.1,2.1,12-1.1,15.8,0.7c1.8-0.3-2.6-0.7,0.9-1.1c1.7-0.2,1.9,0.4,1.8,0.6c0.5-0.1,1-0.1,1.6-0.2C466.6,68.4,463.7,70.4,452.5,72.1z' })
          )
        )
      )
    )
  );
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"st0":"dh-dh-orderud-menu-st0","st1":"dh-dh-orderud-menu-st1","st2":"dh-dh-orderud-menu-st2"};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["dh-analytics-utils"] = {});
}(undefined, function (e) {
  "use strict";
  function n() {
    return window.ga;
  }var t = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];for (var o in t) {
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      }
    }return e;
  };e.createGoogleAnalyticsTracker = function (e) {
    var o = [],
        r = e.name,
        a = e.gaPropertyId,
        i = e.self,
        l = e.context;if (!(r && a && i && l)) throw new Error("Unable to create google analytics tracker. Please pass an object containing name, gaPropertyId, self and context to createGoogleAnalyticsTracker method");var c,
        s,
        d,
        u,
        f,
        g,
        p,
        y,
        w = (c = i.id, s = l.id, d = i.title, u = i.publishedDate, f = c === s, g = document.referrer, { dimension1: c ? "pp:" + c : null, dimension2: d || null, dimension3: u ? String(u.getFullYear()) : null, dimension4: u ? String(u.getMonth() + 1) : null, dimension5: u ? String(u.getDate()) : null, dimension6: g.replace(/^(https?:\/\/)?www./, "$1"), dimension7: g.replace(/^(https?:\/\/)/, "").replace(/^www./, ""), dimension10: f ? null : s ? "pp:" + s : null }),
        v = (p = o, y = !1, function (e, o, r, a, i) {
      if (!r.category || !r.action) throw new Error("Error sending event to google analytics: Event is missing mandatory fields category and/or action");n() ? (y || (function (e, n) {
        window.ga("create", { trackingId: n, cookieDomain: "auto", name: e }), window.ga(e + ".set", "anonymizeIp", !0);
      }(e, o), y = !0), window.ga(e + ".send", "event", function (e, n) {
        var o = {};e.hasOwnProperty("category") && (o.eventCategory = e.category), e.hasOwnProperty("action") && (o.eventAction = e.action), e.hasOwnProperty("label") && (o.eventLabel = e.label), e.hasOwnProperty("value") && (o.eventValue = e.value), o.nonInteraction = e.nonInteraction || !1;var r = t({}, n, e.fieldsObject);return t({}, o, r);
      }(r, a))) : p.push(r);
    }),
        m = setInterval(function () {
      if (n()) for (clearInterval(m); o.length;) {
        var e = o.shift();v(r, a, e, w);
      }
    }, 1e3);return { sendEvent: function sendEvent(e) {
        v(r, a, e, w);
      } };
  }, Object.defineProperty(e, "__esModule", { value: !0 });
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContextId = getContextId;
var POLOPOLY_ID_REGEX = /[1-9]{1,2}\.\d+/g;

function getContextId(url) {
  return extractPolopolyIdFromString(url);
}

function extractPolopolyIdFromString(str) {
  var matches = str.match(POLOPOLY_ID_REGEX);
  if (matches && matches.length) {
    return matches[0];
  }
  return null;
}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"dh-dh-orderud-menu-root","app":"dh-dh-orderud-menu-app"};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menuContainer":"dh-dh-orderud-menu-menuContainer","menu":"dh-dh-orderud-menu-menu","menu__arrow":"dh-dh-orderud-menu-menu__arrow","menu__submenu":"dh-dh-orderud-menu-menu__submenu","menu__item":"dh-dh-orderud-menu-menu__item","menu__item--current":"dh-dh-orderud-menu-menu__item--current","menu__submenu--fadeIn":"dh-dh-orderud-menu-menu__submenu--fadeIn","fadeIn":"dh-dh-orderud-menu-fadeIn","menu__submenu--fadeOut":"dh-dh-orderud-menu-menu__submenu--fadeOut","fadeOut":"dh-dh-orderud-menu-fadeOut","menuContainer--expanded":"dh-dh-orderud-menu-menuContainer--expanded"};

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(18);
module.exports = __webpack_require__(19);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global __HOT__ */
// @jsx h


var _domready = __webpack_require__(3);

var _domready2 = _interopRequireDefault(_domready);

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(1);

var _errorReporting = __webpack_require__(8);

var _App = __webpack_require__(20);

var _App2 = __webpack_require__(14);

var _dhAnalyticsUtils = __webpack_require__(12);

var _getContextId = __webpack_require__(13);

var _provider = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window[_App2.root] = window[_App2.root] || {};

function init() {
  findElements(_App2.root).forEach(function (el) {
    el.id = (0, _dhUtils.createUniqueId)();
    window[_App2.root][el.id] = true;

    // Extract values sent from server
    var name = el.getAttribute('data-name');
    var preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'));
    var errorTrackingEnabled = el.getAttribute('data-error-tracking-enabled') === 'true';

    // setup error reporting
    var simpleErrorReport = (0, _errorReporting.createErrorReporter)(name, errorTrackingEnabled);
    simpleErrorReport.listenAndCatch();

    // Extract metadata required to create google analytics tracker
    var gaPropertyId = el.getAttribute('data-ga-property-id');
    var metadata = JSON.parse(el.getAttribute('data-metadata'));
    var title = metadata.title,
        selfId = metadata.selfId,
        published = metadata.published;

    // create google analytics tracker

    var googleAnalyticsTracker = (0, _dhAnalyticsUtils.createGoogleAnalyticsTracker)({
      name: 'dh',
      gaPropertyId: gaPropertyId,
      self: {
        id: selfId,
        title: title,
        publishedDate: published ? new Date(published) : null
      },
      context: {
        id: (0, _getContextId.getContextId)(document.location.href)
      }
    });

    var sendError = function sendError(message) {
      simpleErrorReport.sendErrorReport({ message: message });
    };

    var sendGaEvent = function sendGaEvent(eventObj) {
      googleAnalyticsTracker.sendEvent(_extends({
        category: 'dh-modul-' + name
      }, eventObj));
    };

    // ... and render with the exact same props as on server
    (0, _preact.render)((0, _preact.h)(
      _provider.Provider,
      { sendGaEvent: sendGaEvent, sendError: sendError },
      (0, _preact.h)(_App.App, _extends({}, preloadedState, { contextId: (0, _getContextId.getContextId)(document.location.href) || 'FORSIDE' }))
    ), el, el.firstChild);

    // Enable webpack hot-reloading
    if (false) {
      // Reload and re-render preact application
      module.hot.accept('./client', function () {
        var _require = require('./components/App'),
            App = _require.App;

        var _require2 = require('../lib/provider'),
            CustomProvider = _require2.Provider;

        (0, _preact.render)((0, _preact.h)(
          CustomProvider,
          { sendGaEvent: sendGaEvent, sendError: sendError },
          (0, _preact.h)(App, _extends({}, preloadedState, { contextId: (0, _getContextId.getContextId)(document.location.href) || 'FORSIDE' }))
        ), el, el.firstChild);
      });
    }
  });
}

if (false) {
  require('preact/debug');
}

function findElements(className) {
  return (0, _dhUtils.toArray)(document.getElementsByClassName(className)).filter(function (el) {
    return !isInitialized(el, className);
  });
}

function isInitialized(el, className) {
  return el.id && window[className][el.id];
}

(0, _domready2.default)(init);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _App = __webpack_require__(14);

var _App2 = _interopRequireDefault(_App);

var _Menu = __webpack_require__(21);

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var App = exports.App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          menuItems = _props.menuItems,
          contextId = _props.contextId;

      return (0, _preact.h)(
        'div',
        { 'class': _App2.default.app },
        (0, _preact.h)(_Menu2.default, { menuItems: menuItems, contextId: contextId })
      );
    }
  }]);

  return App;
}(_preact.Component);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(1);

var _index = __webpack_require__(22);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(15);

var _index4 = _interopRequireDefault(_index3);

var _OrderudLogo = __webpack_require__(10);

var _Arrow = __webpack_require__(23);

var _provider = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

/** @jsx h */

var Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    _classCallCheck(this, Menu);

    var _this = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this));

    _this.handleExpand = function () {
      _this.setState({ expanded: !_this.state.expanded, dirty: true });
      _this.props.sendGaEvent({ action: _this.state.expanded ? 'OPEN_MENU' : 'CLOSE_MENU', label: 'ORDERUD_MENU' });
    };

    _this.state = {
      expanded: false,
      dirty: false
    };
    return _this;
  }

  _createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          expanded = _state.expanded,
          dirty = _state.dirty;
      var _props = this.props,
          menuItems = _props.menuItems,
          contextId = _props.contextId;

      var fadeIn = dirty && expanded;
      var fadeOut = dirty && !expanded;

      return (0, _preact.h)(
        'div',
        { 'class': (0, _dhUtils.bem)(_index4.default.menuContainer, { expanded: expanded }) },
        (0, _preact.h)(
          'nav',
          { 'class': _index4.default.menu },
          (0, _preact.h)(
            'button',
            { onClick: this.handleExpand, 'aria-expanded': expanded.toString() },
            (0, _preact.h)(_OrderudLogo.OrderudLogo, null),
            (0, _preact.h)(
              'span',
              { 'class': 'nrk-sr' },
              'G\xE5ten Orderud \u2013 Meny'
            ),
            (0, _preact.h)(_Arrow.Arrow, { className: _index4.default.menu__arrow })
          ),
          (0, _preact.h)(
            'div',
            { 'class': (0, _dhUtils.bem)(_index4.default.menu__submenu, { fadeIn: fadeIn, fadeOut: fadeOut }), 'aria-hidden': !expanded },
            (0, _preact.h)(
              'ul',
              null,
              menuItems.map(function (menuItem) {
                return (0, _preact.h)(
                  'li',
                  { key: menuItem.url },
                  (0, _preact.h)(_index2.default, { menuItem: menuItem, current: menuItem.id === contextId })
                );
              })
            )
          )
        )
      );
    }
  }]);

  return Menu;
}(_preact.Component);

exports.default = (0, _provider.connect)(function (context) {
  if (context && context.sendGaEvent) {
    return { sendGaEvent: context.sendGaEvent };
  } else {
    return {};
  }
})(Menu);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(1);

var _provider = __webpack_require__(2);

var _index = __webpack_require__(15);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */

var Link = function (_Component) {
  _inherits(Link, _Component);

  function Link() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Link.__proto__ || Object.getPrototypeOf(Link)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      _this.props.sendGaEvent({ action: 'click', label: _this.props.menuItem.anchor });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Link, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          menuItem = _props.menuItem,
          current = _props.current;

      return (0, _preact.h)(
        'a',
        {
          href: menuItem.url,
          'class': (0, _dhUtils.bem)(_index2.default.menu__item, { current: current }),
          onClick: this.handleClick },
        menuItem.text
      );
    }
  }]);

  return Link;
}(_preact.Component);

exports.default = (0, _provider.connect)(function (context) {
  if (context && context.sendGaEvent) {
    return { sendGaEvent: context.sendGaEvent };
  } else {
    return {};
  }
})(Link);

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = undefined;

var _preact = __webpack_require__(0);

var Arrow = exports.Arrow = function Arrow(props) {
  return (0, _preact.h)(
    'svg',
    {
      'class': props.className,
      width: '40px', height: '40px', viewBox: '0 0 40 40', version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
    (0, _preact.h)(
      'g',
      null,
      (0, _preact.h)('polygon', { points: '20 24.8860294 13 17.1139706 27 17.1139706 22.6470434 21.9470326' })
    )
  );
}; //  @jsx h

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// v1-bundle-4887fe08b589cc2d5c71.js